import React from 'react';
import Bone from 'app/shared/components/Bone';

import {
    Col,
    Row,
} from '@zillow/zrs-comet';

import { StyledPDPContentSkeletonContainer } from './StyledComponents';

const PDPContentSectionSkeleton = () => (
    <React.Fragment>
        <Row paddingY="xs">
            <Col>
                <Bone dark={true} type="bar" className="PDPContentSkeleton-bone-title" />
            </Col>
        </Row>

        <Row paddingY="xs">
            <Col>
                <Bone dark={true} type="line" className="PDPContentSkeleton-bone-text-1" />
            </Col>
        </Row>


        <Row paddingY="xs">
            <Col>
                <Bone dark={true} type="line" className="PDPContentSkeleton-bone-text-2" />
            </Col>
        </Row>

        <Row paddingY="xs">
            <Col>
                <Bone dark={true} type="line" className="PDPContentSkeleton-bone-text-1" />
            </Col>
        </Row>
    </React.Fragment>
);

const PDPContentSkeleton = () => (
    <StyledPDPContentSkeletonContainer className="PDPContentSkeleton">
        <PDPContentSectionSkeleton />
        <PDPContentSectionSkeleton />
    </StyledPDPContentSkeletonContainer>
);


export default PDPContentSkeleton;
